import { configureStore, Store } from '@reduxjs/toolkit';
import reducers from './reducers';
import auth, { setToken } from './services/auth.service';
import { baseApi } from './services/base.service';

let storeConfig: Store;

export const store = (token: string) => {
  auth({ token }, setToken);

  storeConfig = configureStore({
    reducer: { ...reducers, auth },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
  });

  return storeConfig;
};

export type AppDispatch = typeof storeConfig.dispatch;
export type RootState = ReturnType<typeof storeConfig.getState>;
